import * as React from 'react';
import type {
    BaseDialogProps as UnifiedShareDialogProps,
    ShareDialogGlassboxLogger,
    EvaluatedFeatures,
} from '@prezi/share-dialog';
import { ShareDialog } from '@prezi/share-dialog';

// Temporary backward compatibility until we update Boxfish to use new API

export type BackwardCompatibleShareDialogProps = LegacyShareDialogProps | UnifiedShareDialogProps;

export function BackwardCompatibleShareDialog(props: BackwardCompatibleShareDialogProps) {
    // Check if legacy props structure
    if ('useUnifiedShareDialog' in props) {
        props = convertLegacyPropsToUnifiedProps(props as LegacyShareDialogProps);
    }

    return <ShareDialog {...props} />;
}

type LegacyShareDialogProps = {
    useUnifiedShareDialog: true;
    rootNodeId: string;
    openDialog: 'viewlinks' | 'privacysettings';
    metaData: {
        preziOid: string;
        userOid: string;
        currentUserId: string;
        isReferralFeatureEnabled: boolean;
    };
    dialogClosed: VoidFunction;
    openPaywallPanel: (
        feature: 'pitch_analytics' | 'pitch_privacy_private' | 'pitch_master',
        page: 'viewlinks' | 'privacysettings',
    ) => void;
    glassboxLogger: ShareDialogGlassboxLogger;
    evaluatedFeatures?: EvaluatedFeatures;
};

function convertLegacyPropsToUnifiedProps({
    openDialog,
    rootNodeId,
    metaData,
    dialogClosed,
    openPaywallPanel,
    glassboxLogger,
    evaluatedFeatures,
}: LegacyShareDialogProps): UnifiedShareDialogProps {
    const userId = parseInt(metaData.currentUserId, 10);

    return {
        isOpen: true,
        page: openDialog === 'viewlinks' ? 'viewLinks' : 'unified',
        rootNodeId,
        documentOid: metaData.preziOid,
        onClose: dialogClosed,
        onUpgrade: (feature, page) => openPaywallPanel(feature, page === 'viewLinks' ? 'viewlinks' : 'privacysettings'),
        glassboxLogger,
        showReferralCopyAndCode: metaData.isReferralFeatureEnabled,
        userInfo:
            isNaN(userId) || metaData.userOid === null
                ? undefined
                : {
                      userId,
                      userOid: metaData.userOid,
                  },
        evaluatedFeatures,
    };
}
